import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LeagueAnalysisView from '../views/LeagueAnalysisView.vue'
import LeagueTableView from '../views/LeagueTableView.vue'
import MatchReviewView from '../views/MatchReviewView.vue'
import MatchesView from '../views/MatchesView.vue'
import PlayerAnalysisView from '../views/PlayerAnalysisView.vue'
import TeamAnalysisView from '../views/TeamAnalysisView.vue'

const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/home', name: 'Home', component: HomeView },
  { path: '/league-analysis', name: 'LeagueAnalysis', component: LeagueAnalysisView },
  { path: '/league-table', name: 'LeagueTable', component: LeagueTableView },
  { path: '/match-review', name: 'MatchReview', component: MatchReviewView },
  { path: '/matches', name: 'Matches', component: MatchesView },
  { path: '/player-analysis', name: 'PlayerAnalysis', component: PlayerAnalysisView },
  { path: '/team-analysis', name: 'TeamAnalysis', component: TeamAnalysisView },
]

export function createRouterInstance(ssrContext) {
  const history = ssrContext?.type === 'ssr' 
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL)

  return createRouter({
    history,
    routes
  })
}

const router = createRouterInstance()

export default router